"use client";

import React, { ReactNode } from "react";

interface PopUpButtonProps {
  link: string;
  color: string;
  icon: ReactNode;
}

const PopUpButton: React.FC<PopUpButtonProps> = ({ link, color, icon }) => {
  const openPopup = (e: React.MouseEvent<HTMLAnchorElement>, url: string) => {
    e.preventDefault();
    window.open(
      url,
      "_blank",
      "width=600,height=400,scrollbars=no,toolbar=no,menubar=no"
    );
  };

  return (
    <a
      href={link}
      onClick={(e) => openPopup(e, link)}
      target="_blank"
      rel="noopener noreferrer"
      className={`text-white py-2 px-4 rounded`}
      style={{ backgroundColor: color }}
    >
      {icon}
    </a>
  );
};

export default PopUpButton;
